'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'GetawaysCalendar',
    module: requireOrNull('../../../../modules/getaways/frontend/calendar'),
  },
  {
    name: 'GetawaysSearchWidget',
    module: requireOrNull(
      '../../../../modules/getaways/frontend/search_widget'
    ),
  },
  {
    name: 'GetawaysTripAdvisor',
    module: requireOrNull('../../../../modules/getaways/frontend/trip_advisor'),
    featureCheck: serverObj => serverObj.tripAdvisor,
  },
];

const nonCritModules = [
  {
    name: 'AsyncScripts',
    module: requireOrNull('../async_scripts/getaways'),
  },
  {
    name: 'Merchant',
    module: requireOrNull('../../../../modules/merchant/frontend/lazy_load'),
    featureCheck: serverObj =>
      serverObj.merchant &&
      serverObj.merchant.clientSideMerchantLocations &&
      serverObj.loadSwitch &&
      serverObj.loadSwitch.shouldLoadLazyLoadMerchantLocations,
  },
  {
    name: 'Wishlist',
    module: requireOrNull(
      '../../../../modules/wishlist_button/frontend/wishlist'
    ),
    featureCheck: serverObj => serverObj.wishlist,
  },
];

module.exports = { critModules, nonCritModules };
